interface Number {
  px: string;
  rem: String;
}

// eslint-disable-next-line no-extend-native
Object.defineProperties(Number.prototype, {
  px: {
    get(this: Number) {
      return `${this}px`;
    },
  },
  rem: {
    get(this: Number) {
      return `${this}rem`;
    },
  },
});
